/**
 * Onboarding path matching utilities.
 *
 * Extracted as a pure module so it can be tested without side effects.
 * Used by SessionValidator (App.tsx) and OnboardingGate to determine
 * whether to skip SSO redirect on the current path.
 */

/**
 * Check if the current path is an onboarding or auth callback path
 * that should skip SSO redirect.
 *
 * INVARIANT: Must match both "/onboarding" (no trailing slash) and "/onboarding/..."
 * to prevent redirect loops when users arrive without an SSO session.
 * This was the root cause of users being bounced to login after email verification.
 */
export function isOnboardingOrCallbackPath(pathname: string): boolean {
  return pathname.startsWith('/auth/callback') ||
         pathname === '/onboarding' ||
         pathname.startsWith('/onboarding/')
}
